import { useEffect } from "react";
import Splasher from "url:../assets/Splasher.png";

export default function SplashLoader({ onFinish }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 2200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed inset-0 bg-gradient-to-b from-orange-50 to-white flex flex-col items-center justify-center z-50 px-4">
      
      {/* Logo */}
      <img
        src={Splasher}
        alt="Logo"
        className="
          w-64          /* mobile */
          sm:w-72       /* small devices */
          md:w-96       /* tablets */
          lg:w-[28rem]  /* laptops */
          xl:w-[32rem]  /* large screens */
          mb-10 md:mb-14
          animate-fadeIn
        "
      />

      {/* Loader */}
      <div
        className="
          relative
          w-40          /* mobile */
          sm:w-52
          md:w-64
          lg:w-72
          h-[3px] md:h-[4px]
          bg-orange-100
          overflow-hidden
          rounded
        "
      >
        <div className="absolute top-0 left-0 h-full w-1/2 bg-orange-500 animate-loader shadow-[0_0_12px_rgba(255,115,0,0.7)]" />
      </div>

    </div>
  );
}